<template>
  <div
    style="max-width: 1000px;margin-left:auto; margin-right: auto;margin-bottom: 10px; width: 100%;background-color: white;min-height: calc(100% + 265px);box-shadow: 0px 2px 12px 0px #D2DAE1;">
    <div class="wrap-detail">
      <div class="wrap-detail-info">
        <div class="flex-column wrap-detail-left">
          <div class="wrap-detail-left-img">
            <l-d-pic-zoom :generalName="generalName" :url="getShowPic.showImg"
                          :videourl="getShowPic.videourl"
                          @videoclick="onVideoPlay"></l-d-pic-zoom>
            <!--            <video :src="videoplayurl" alt=""-->
            <!--                   autoplay-->
            <!--                   controls-->
            <!--                   controlsList="nodownload"-->
            <!--                   ref="videoref"-->
            <!--                   style="height:263px;width: 100%;position: absolute;top: 0;left: 0;background-color: #A8A8A8"-->
            <!--                   v-show="videoplayurl"/>-->
            <!--            <img @click.stop="onVideoStop" src="../../../assets/common/ic_cuowu.png"-->
            <!--                 style="position: absolute;top: 0;right: 0;width: 20px;height: 20px"-->
            <!--                 v-show="videoplayurl">-->

            <!--            <div-->
            <!--              style="height:261px;width: 348px;position: absolute;top: 0;left: 0;background-color: #A8A8A8;display: block"-->
            <!--              v-show="videoplayali">-->
            <!--              <video-player :vid="videoplayali" @canplay="canreadyplay"-->
            <!--                            @onEnded="onEnded"-->
            <!--                            aspectRatio="4:3"-->
            <!--                            class="video-style"-->
            <!--                            ref="players"-->
            <!--                            style="width: 348px;height: 261px;"/>-->
            <!--              &lt;!&ndash;position: absolute; top: 50%;left: 50%; transform: translate(-50%, -50%);&ndash;&gt;-->
            <!--              <img @click.stop="onAliVideoStop" src="../../../assets/common/ic_cuowu.png"-->
            <!--                   style="position: absolute;top: 0;right: 0;width: 20px;height: 20px"-->
            <!--                   v-show="videoplayali">-->
            <!--            </div>-->
          </div>
          <div class="preview-list clear" v-if="prewList && prewList.length">
            <div @click="onPrevImgClick()" class="arrow-prev">
              <i color="#BABABA" style="font-size: 40px" class="el-icon-arrow-left"/>
            </div>
            <div class="spec-items" ref="navWrap">
              <ul :style="[{width: 60 * prewList.length + 'px'},navStyle]" class="clear" ref="nav">
                <template v-for="(item, index) in prewList">
                  <li :class="index === preImgIndex ? 'pre-img-active' : ''" :key="index"
                      @click="onPreImgItemClick(index)">
                    <img :src="item.imgUrl" @mousemove="onPreImgItemClick(index)" alt="img">
                  </li>
                </template>
              </ul>
            </div>
            <div @click="onNextImgClick()" class="arrow-next">
              <i color="#BABABA" style="font-size: 40px" class="el-icon-arrow-right"/>
            </div>
          </div>
        </div>
        <div class="wrap-detail-right">
          <div class="detail-right-title">
            <!--<span>{{generalName}}</span>-->
            <span>{{ form.model.productName }}</span>
          </div>
          <div class="detail-right-desc">{{ form.model.productBrand }}</div>
          <div class="m-t-10" v-if="form.model.sellingPoint">
            <el-tag type="danger" :key="index" class="m-r-10 m-v-5"
                    v-for="(item,index) in  form.model.sellingPoint">{{ item }}
            </el-tag>
          </div>
          <!--          <div class="detail-right-limit" style="display:none;">-->
          <!--            <img alt="limit" class="detail-right-limit-img"-->
          <!--                 src="../../../assets/product/ic_product_limit_purchase.png">-->
          <!--            <img alt="watch" class="detail-right-limit-watch"-->
          <!--                 src="../../../assets/product/ic_product_limit_watch.png">-->
          <!--            <p class="margin-left-10">据抢购结束</p>-->
          <!--            <p class="margin-left-15">00 天 08 时 38 分 56 秒</p>-->
          <!--            <div class="detail-right-process">-->
          <!--              <p class="detail-right-process-value"></p>-->
          <!--              <p class="detail-right-process-text">已抢34%</p>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="detail-right-active-price">
            <span class="fz-12 color-99">销售价格</span>
            <span class="fz-16 color-red m-l-20">￥<span class="font-bold"
                                                        style="letter-spacing:-1px;">{{ getShowPrice }}</span></span>
          </div>
          <div class="detail-right-discounts" style="display: none">
            <span class="fz-12 color-99" style="letter-spacing: 7px">优 惠</span>
            <div class="discounts-list">
              <!--              <div class="discounts-item">-->
              <!--                <p class="discounts-item-title">赠品</p>-->
              <!--                <img alt="discount" class="discounts-item-img" src="../../../assets/product/ic_product_icon.png"/>-->
              <!--                <p class="discounts-item-count">X<span class="margin-left-5 fz-14 font-bold">1</span></p>-->
              <!--                <p class="discounts-item-desc">赠完为止</p>-->
              <!--              </div>-->
              <div class="discounts-item">
                <p class="discounts-item-title">满减</p>
                <p class="discounts-item-desc">满一件打八折</p>
              </div>
              <div class="discounts-item">
                <p class="discounts-item-title">优惠套餐</p>
                <p class="discounts-item-desc">该商品共有6个优惠套装</p>
              </div>
            </div>
          </div>
          <div class="detail-right-spec">
            <span class="fz-12 color-99 flex-shrink-0" style="letter-spacing: 7px;margin-top: 5px">规 格</span>
            <ul class="detail-right-spec-list">
              <template v-for="(item, index) in specList">
                <li :class="index === specIndex ? 'spec-active' : ''" :key="index" @click="onSpecItemClick(index)"
                    class="detail-right-spec-item">
                  <img alt="spec" src="../../../assets/common/ic_product_spec_selected.png"
                       v-show="index === specIndex">
                  {{ item.name }}
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
      <!--      商品信息-->
      <el-descriptions class="m-t-30 my-label" title="商品信息" :column="4" size="medium" border>
        <el-descriptions-item :span="4" label="所属分类">
          <el-tag class="m-r-10"
                  :key="tag.categoryId"
                  v-for="tag in getShowCategoryList"
                  :disable-transitions="false">
            {{ tag.name }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item :span="2" label="品牌名">
          {{ form.model.productBrand }}
        </el-descriptions-item>
        <el-descriptions-item :span="2" label="商品编码">
          {{ form.model.productNo }}
        </el-descriptions-item>
        <el-descriptions-item :span="2" label="生产企业">
          {{ form.model.manufacturer }}
        </el-descriptions-item>
        <el-descriptions-item :span="2" label="最高限购数量">
          {{ form.model.limitNum }}
        </el-descriptions-item>
        <!--        <el-descriptions-item :span="2" label="运费模版">-->
        <!--          {{ getDeliveryName }}-->
        <!--        </el-descriptions-item>-->
        <el-descriptions-item :span="2" label="商品剂型">
          {{ form.model.formulation }}
        </el-descriptions-item>
        <el-descriptions-item :span="2" label="会员等级限制">
          <el-tag class="m-r-10"
                  :key="tag"
                  v-for="tag in getShowGradeName"
                  :disable-transitions="false">
            {{ tag.name }}
          </el-tag>
        </el-descriptions-item>
        <!--        <el-descriptions-item :span="2" label="最低限购数量">-->
        <!--          {{ form.model.minLimit }}-->
        <!--        </el-descriptions-item>-->

      </el-descriptions>
      <el-descriptions class="m-t-30 my-label" title="规格信息" :column="4" size="medium">
      </el-descriptions>
      <el-table size="mini" :data="form.model.specMany.specList" :span-method="objectSpanMethod" border
                style="width: 100%; margin-top: 10px">
        <el-table-column :label="item.groupName" :key="item.groupName"
                         v-for="(item, index) in form.model.specMany.specAttr">
          <template slot-scope="scope">
            {{ scope.row.rows[index].specValue }}
          </template>
        </el-table-column>
        <el-table-column label="规格图片" :width="70">
          <template slot-scope="scope">
            <img v-img-url="scope.row.specForm.imagePath" alt="" width="35" height="35"/>
          </template>
        </el-table-column>
        <el-table-column label="商家编码">
          <template slot-scope="scope">
            {{ scope.row.specForm.productNo || '' }}
          </template>
        </el-table-column>
        <el-table-column label="规格码">
          <template slot-scope="scope">
            {{ scope.row.specForm.specNo || '' }}
          </template>
        </el-table-column>
        <el-table-column label="运费模版">
          <template slot-scope="scope">
            {{ getDeliveryText(scope.row.specForm.deliveryId) || '' }}
          </template>
        </el-table-column>
        <el-table-column label="供货价格(元)">
          <template slot-scope="scope">
            {{ scope.row.specForm.supplierPrice || '' }}
          </template>
        </el-table-column>
        <!--        <el-table-column label="销售价(元)">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-form-item-->
        <!--              label=""-->
        <!--              :rules="[{ required: true, message: ' ' }]"-->
        <!--              :prop="'model.specMany.specList.' + scope.$index + '.specForm.productPrice'"-->
        <!--              style="margin-bottom: 0;"-->
        <!--            >-->
        <!--              <el-input size="small" prop="productPrice" readonly-->
        <!--                        :value="getProductPrice(scope.row)"></el-input>-->
        <!--            </el-form-item>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column label="建议销售价(元)">
          <template slot-scope="scope">
            {{ scope.row.specForm.referencePrice || '' }}
          </template>
        </el-table-column>
        <el-table-column label="库存">
          <template slot-scope="scope">
            {{ scope.row.specForm.stockNum || '' }}
          </template>
        </el-table-column>
        <el-table-column label="重量(kg)">
          <template slot-scope="scope">
            {{ scope.row.specForm.productWeight || '' }}
          </template>
        </el-table-column>
        <el-table-column label="最低限购">
          <template slot-scope="scope">
            {{ scope.row.specForm.minLimit || '' }}
          </template>
        </el-table-column>
      </el-table>
      <el-descriptions class="m-t-30 my-label" title="使用方法" :column="4" size="medium"
                       v-if="form.model.usageList && form.model.usageList.length">
      </el-descriptions>
      <el-table size="small" :data="form.model.usageList" border style="width: 100%"
                :header-cell-style="getUsageTableCellStyle"
                v-if="form.model.usageList && form.model.usageList.length">
        <el-table-column prop="cropTypeName" align="center" label="作物分类">
        </el-table-column>
        <el-table-column prop="cropName" align="center" label="作物"></el-table-column>
        <el-table-column prop="diseaseName" align="center" label="防治对象">
        </el-table-column>
        <el-table-column prop="formulationDosage" align="center" label="制剂和用药量">
        </el-table-column>
        <el-table-column prop="useMethod" align="center" label="使用方法">
        </el-table-column>
        <!--      <el-table-column prop="isPicture" label="图片" width="100">-->
        <!--        <template slot-scope="scope">-->
        <!--          <span v-if="scope.row.isPicture==0">没有</span>-->
        <!--          <span v-else>有</span>-->
        <!--        </template>-->
        <!--      </el-table-column>-->
        <!--          <el-table-column prop="sort" label="排序" width="100"></el-table-column>-->
        <!--        <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>-->
        <!--        <el-table-column fixed="right" label="操作" width="100">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-button @click="editClick(scope.row)" type="text" size="small">-->
        <!--              编辑-->
        <!--            </el-button>-->
        <!--            <el-button @click="delClick(scope.row,scope.$index)" type="text" size="small">删除-->
        <!--            </el-button>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
      </el-table>
      <el-descriptions class="m-t-30 my-label" title="详情图片" :column="4" size="medium"
                       v-if="form.model.contentImage && form.model.contentImage.length">
      </el-descriptions>
      <ul v-if="form.model.contentImage && form.model.contentImage.length">
        <li v-for="(item,index) in form.model.contentImage" :key="index">
          <img :src="item.filePath" alt="" style="width:100%;object-fit: cover"/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import LDPicZoom from '../../../components/common/LDPicZoom'
import {getFormatPrice} from '../../../utils/tools'

export default {
  name: 'ProductDetail',
  components: {LDPicZoom},
  inject: ['form'],
  data () {
    return {
      generalName: '',           //通用名称
      preImgIndex: 0,           //商品图片选择序号
      prewList: [],             //商品浏览列表
      specList: [],
      navStyle: {               //图片组左移
        transform: ''
      },
      specIndex: -1,
    }
  },
  computed: {
    getShowGradeName () {
      let tag = []
      let gradeIds = this.form.model.gradeIds
      let gradeList = this.form.gradeList
      if (gradeIds && gradeIds.length && gradeList && gradeList.length) {
        for (let i = 0; i < gradeList.length; i++) {
          let item = gradeList[i]
          if (gradeIds.includes(item.gradeId)) {
            tag.push({
              name: item.name || ''
            })
          }
        }

      }
      return tag
    },
    getShowCategoryList () {
      let list = []
      let supplierCategory = this.form.supplierCategory
      if (supplierCategory) {
        let category = this.form.category
        let clist = category.filter(res => {
          return res.supplierCategoryId === supplierCategory.categoryId
        })
        let selIds = this.form.model.categoryIds
        if (selIds && selIds.length) {
          for (let i = 0; i < selIds.length; i++) {
            if (clist && clist.length) {
              let proResultList = []
              this.findPath(clist, selIds[i], proResultList)
              if (proResultList && proResultList.length) {
                let info = proResultList[0]
                list.push(info)
              }
            }
          }
        }
      }
      return list
    },
    getShowPic () {
      let showImg = require('../../../assets/common/ic_default_pro@2x.png')
      let videourl = ''
      let index = this.preImgIndex
      if (this.form.model && this.form.model.image && this.form.model.image.length) {
        this.prewList = this.form.model.image.filter(item => {
          return item.filePath
        }).map(item => {
          return {
            imgUrl: item.filePath,
            videourl: ''
          }
        })
        if (this.prewList && this.prewList.length) {
          if (this.prewList.length > index) {
            showImg = this.prewList[index].imgUrl
            videourl = this.prewList[index].videourl
          } else {
            showImg = this.prewList[0].imgUrl
            videourl = this.prewList[0].videourl
          }
        }
      }
      return {
        showImg: showImg,
        videourl: videourl,
      }
    },
    getShowPrice () {
      let showProce = '0.00'
      this.specList = []
      if (this.form && this.form.model && this.form.model.specList && this.form.model.specList.length) {
        this.specList = this.form.model.specList.filter(res => {
          return res.skuStatus === 0
        }).map(res => {
          return {
            name: res.specName || '',
            prices: res.specForm ? res.specForm.productPrice || '0.00' : '0.00'
          }
        })
      }
      if (this.specIndex < 0) {
        let productPrice = this.form.model.productPrice
        let highPrice = this.form.model.highPrice
        if (productPrice !== highPrice) {
          showProce = getFormatPrice(String(productPrice)) + ' --- ' + getFormatPrice(String(highPrice)) + '元'
        } else {
          showProce = getFormatPrice(String(productPrice)) + '元'
        }
      } else if (this.specList && this.specList.length) {
        if (this.specIndex < this.specList.length) {
          let specitem = this.specList[this.specIndex]
          showProce = getFormatPrice(String(specitem.prices)) + '元'
        }
      }
      return showProce
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    getUsageTableCellStyle () {
      return 'background:	#AADEA5; color:#666;'
    },
    getProductPrice (row) {
      let productPrice = 0
      if (row.specForm.supplierPrice) {
        productPrice += parseFloat(row.specForm.supplierPrice)
      }
      if (this.form.model.isEnableCommission === 1) {
        if (row.specForm.commissionPrice) {
          productPrice += parseFloat(row.specForm.commissionPrice)
        }
        if (row.specForm.platRetentionPrice) {
          productPrice += parseFloat(row.specForm.platRetentionPrice)
        }
      }
      row.specForm.productPrice = productPrice || 0
      return row.specForm.productPrice
    },
    /*表格跨行*/
    objectSpanMethod ({row, column, rowIndex, columnIndex}) {
      var specAttr = this.form.model.specMany.specAttr
      // 规格组合总数 (table行数)
      var totalRow = 1
      //比如2个规格,只有第一列有多行
      if (columnIndex < specAttr.length - 1) {
        let startRowIndex = columnIndex + 1
        let endRowIndex = specAttr.length - 1
        for (var i = startRowIndex; i <= endRowIndex; i++) {
          totalRow *= specAttr[i].specItems.length
        }
        if (rowIndex % totalRow === 0) {
          return {
            rowspan: totalRow,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    findPath (list, id, resultList) {
      let hasInLine = false
      if (list && list.length) {
        for (let i = 0; i < list.length; i++) {
          let res = list[i]
          if (res.categoryId === id) {
            resultList.push(res)
            hasInLine = true
            break
          } else if (res.children && res.children.length) {
            let result = this.findPath(res.children, id, resultList)
            hasInLine = result
            if (result) {
              // resultList.push(res.name)
              break
            }
          }
        }
      }
      return hasInLine
    },
    getDeliveryText (deliveryId) {
      let text = ''
      let deliveryList = this.form.delivery
      if (deliveryList && deliveryList.length) {
        let deliveryInfo = deliveryList.find(e => {
          return e.deliveryId === deliveryId
        })
        if (deliveryInfo) {
          text = deliveryInfo.name || ''
        }
      }
      return text
    },
    onNextImgClick () {
      if (this.prewList.length < 6) {
        if (this.preImgIndex < this.prewList.length - 1) {
          this.preImgIndex = this.preImgIndex + 1
        }
      } else {
        const navWidth = this.$refs.navWrap.offsetWidth
        let currectPosition = this.getCurrentScrollOffset() || 0
        let allwidth = this.$refs.nav.scrollWidth
        let newPosition = currectPosition + navWidth
        let newWidth = currectPosition + navWidth * 2
        if (newWidth >= allwidth) {
          newPosition = currectPosition + navWidth - (newWidth - allwidth)
        }
        let position = newPosition
        this.setOffset(position)
      }
    },
    onPrevImgClick () {
      if (this.prewList.length < 6) {
        if (this.preImgIndex > 0) {
          this.preImgIndex = this.preImgIndex - 1
        }
      } else {
        const navWidth = this.$refs.navWrap.offsetWidth
        let position = this.getCurrentScrollOffset() - navWidth
        if (position < 0) {
          position = 0
        }
        this.setOffset(position)
      }
    },
    setOffset (value) {
      this.navStyle.transform = `translateX(-${value}px)`
    },
    getCurrentScrollOffset () {
      const {navStyle} = this
      return navStyle.transform
        ? Number(navStyle.transform.match(/translateX\(-(\d+(\.\d+)*)px\)/)[1])
        : 0
    },

    onPreImgItemClick (index) {
      if (this.preImgIndex !== index) {
        this.preImgIndex = index
      }
    },
    onVideoPlay () {

    },
    onSpecItemClick (index) {
      this.specIndex = index
    }
  }
}
</script>

<style scoped>
.my-label >>> .is-bordered {
  table-layout: fixed !important;
}
</style>
<style lang="scss" scoped>


.noselect-style {
  color: #666666;
  font-size: 14px;
  white-space: nowrap;
}

.select-active {
  background-color: #e4393c;
  color: white;
}

.wrap-detail {
  width: 880px;
  height: auto;
  padding: 35px 0;
  margin: 0 auto;
  background-color: white;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;

  .wrap-detail-info {
    display: flex;

    .wrap-detail-left {
      justify-content: flex-start;
      width: 350px;

      .wrap-detail-left-img {
        width: 350px;
        height: 350px;
        border: 1px solid rgba(186, 186, 186, 1);
        position: relative;

        img {
          width: 298px;
          height: 298px;
        }

        .icon-search {
          position: absolute;
          bottom: 0;
          right: 0;
          cursor: pointer;
          color: #999999;
          padding: 3px;
        }
      }

      .preview-list {
        width: 350px;
        margin-top: 10px;
        position: relative;

        .arrow-prev, .arrow-next {
          float: left;
          position: absolute;
          top: 50%;
          margin-top: -20px;
          cursor: pointer;
        }

        .arrow-prev {
          left: -12px;
        }

        .arrow-next {
          right: -12px;
        }

        .spec-items {
          width: 300px;
          margin: 0 auto;
          overflow: hidden;

          ul {
            overflow: hidden;

            li {
              cursor: pointer;
              margin: 0 5px;
              float: left;
              height: 50px;
              width: 50px;

              img {
                width: 50px;
                height: 50px;
              }
            }

            li.pre-img-active {
              border: 1px solid rgba(255, 0, 0, 1);
              width: 50px;
              height: 50px;

              img {
                width: 48px;
                height: 48px;
              }
            }
          }
        }
      }
    }

    .wrap-detail-right {
      margin-left: 15px;

      .detail-right-title {
        font-size: 14px;

        /*span:first-child {*/
        /*background-color: #FF6600;*/
        /*color: white;*/
        /*padding: 2px 5px;*/
        /*}*/

        span:first-child {
          /*margin-left: 10px;*/
          color: black;
          line-height: 28px;
          font-weight: 800;
          font-size: 16px;
        }
      }

      .detail-right-desc {
        margin-top: 5px;
      }

      .detail-right-limit {
        display: flex;
        align-items: center;
        width: 100%;
        height: 35px;
        line-height: 35px;
        margin-top: 10px;
        background-color: #F43938;
        padding: 0 5px;
        color: white;
        font-size: 14px;

        .detail-right-limit-img {
          width: 98px;
          height: 25px;
        }

        .detail-right-limit-watch {
          width: 14px;
          height: 15px;
          margin-left: 18px;
        }

        .detail-right-process {
          width: 75px;
          height: 16px;
          line-height: 16px;
          background: #FFF0F0;
          border-radius: 7px;
          margin-left: 10px;
          position: relative;

          .detail-right-process-text {
            color: #FF0F00;
            font-size: 12px;
            position: absolute;
            width: 100%;
            left: 50%;
            top: 50%;
            margin-top: -8px;
            margin-left: -25%;
          }

          .detail-right-process-value {
            background-color: #FFE100;
            width: 34%;
            height: 100%;
            border-radius: 7px;
          }
        }
      }

      .detail-right-active-price {
        display: flex;
        margin-top: 10px;
        align-items: baseline;
      }

      .detail-right-discounts {
        display: flex;
        margin-top: 20px;

        .discounts-list {
          margin-left: 15px;

          .discounts-item {
            display: flex;
            align-items: center;
            margin-top: 12px;

            .discounts-item-title {
              width: 58px;
              height: 20px;
              text-align: center;
              border: 1px solid #FF6600;
              color: #FF6600;
              font-size: 12px;
            }

            .discounts-item-img {
              width: 23px;
              height: 22px;
              margin-left: 8px;
            }

            .discounts-item-count {
              font-size: 12px;
              color: #FF6600;
              margin-left: 5px;
            }

            .discounts-item-desc {
              color: #333333;
              font-size: 12px;
              margin-left: 8px;
            }
          }

          .discounts-item:first-child {
            margin-top: 0;
          }
        }
      }

      .detail-right-spec {
        display: flex;
        margin-top: 20px;

        .detail-right-spec-list {
          display: flex;
          flex-wrap: wrap;

          .detail-right-spec-item {
            height: 30px;
            line-height: 30px;
            padding: 0 10px;
            margin-left: 15px;
            font-size: 14px;
            color: #999999;
            border: 1px solid #BABABA;
            margin-bottom: 15px;
            cursor: pointer;
            position: relative;
          }

          .spec-active {
            border-color: #FF6600;

            img {
              position: absolute;
              width: 19px;
              height: 19px;
              bottom: 0;
              right: 0;
            }
          }
        }
      }
    }
  }

  .wrap-type {
    margin-top: 50px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: #F7F7F7;
    color: #333333;
    font-size: 14px;

    li {
      float: left;
      padding: 0 26px;
      cursor: pointer;
    }

    li.active-type {
      color: #FF6600;
      border-bottom: 1px solid #FF6600;
    }
  }

  .wrap-desc {
    margin: 25px 25px 0;
    color: #333333;
    font-size: 14px;

    .wrap-desc-row {
      display: flex;
      width: 100%;
      margin-top: 10px;

      p {
        width: 31%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        margin-right: 2%;
      }
    }
  }

  .wrap-title {
    font-size: 18px;
    font-weight: 600;
    color: black;
    margin-top: 30px;
  }

  .wrap-list {
    margin-top: 15px;
    width: 840px;
    background-color: white;
    align-items: flex-start;

    .wrap-list-item {
      border: 1px solid #E2E2E2;
      margin: 5px 0;
      width: 100%;
    }

    .head-style {
      border-bottom: 1px solid #E2E2E2;
      background-color: #f8f8f9;

      .head-media, .head-content, .head-operation {
        height: 40px;
        line-height: 40px;
        border-right: 1px solid #E2E2E2;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
      }

      .head-operation {
        border-right: none;
      }
    }

    .body-style {
      .body-media {
        border-right: 1px solid #E2E2E2;
        height: 90px;
        position: relative;

        .body-media-img {
          width: 120px;
          height: 70px;
        }

        .body-media-img-count {
          position: absolute;
          bottom: 15px;
          right: 20px;
          background-color: #33333388;
          width: 30px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          color: white;
        }
      }

      .body-content {
        border-right: 1px solid #E2E2E2;
        height: 90px;
        padding: 10px;

        .body-content-title {
          font-size: 15px;
          color: #04D4E6;
          font-weight: bold;
          line-height: 30px;
        }

        .body-content-desc {
          color: #333;
          max-width: 600px;
          font-size: 13px;
          line-height: 20px;
          height: 80px;
          margin-top: 6px;
        }
      }
    }

    .head-media, .body-media {
      width: 160px;
    }

    .head-content, .body-content {
      width: 60%;
    }

    .head-operation, .body-operation {
      width: 160px;
    }

    .body-operation-btn {
      width: 30px;
      cursor: pointer;
      margin-left: 10px;
      color: #0091FF;
    }
  }
}

.video-style ::v-deep .video-js .vjs-big-play-button {
  /*
   播放按钮换成圆形
  */
  font-size: 2em;
  border-radius: 1em;
}

.copyright_split {
  margin: 0 10px;
}

.color_normal_style {
  color: green;
}

.color_gray_style {
  color: #666;
}

.color_red_style {
  color: red;
}

.border_text {
  border-right: 1px solid rgba(226, 226, 226, 1);
  flex-shrink: 0;
}

.roundclass-style {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: white;
  border: 1px solid #ececec;
}

.blue_sstyle {
  background-color: blue;
}

.lin2 {
  color: #333;
  max-width: 600px;
  font-size: 13px;
  line-height: 20px;
  height: 40px;
  margin-top: 6px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 2; /** 显示的行数 **/
  overflow: hidden; /** 隐藏超出的内容 **/
}

</style>



// WEBPACK FOOTER //
// src/views/product/components/ProductDetail.vue